module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-campaign-header-bg-sp-a6e32cb024d6f1a05468abb990ce4a87.png";